/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Types de déclaration qui s'appuient sur une déclaration de PACS déjà
 * existante : ils ne peuvent être établis que si celle-ci a bien été
 * enregistrée au registre.
 */
export const TYPES_DECLARATION_SUR_PACS_ENREGISTRE = [
  'modificative',
  'dissolution',
];

/**
 * Contrôle métier : une déclaration modificative ou de dissolution ne peut
 * être établie que sur une déclaration de PACS enregistrée au registre
 * (`editionRegistre`, positionné depuis la fiche du PACS). Les autres types de
 * déclaration (projet, initiale) ne sont pas concernés par ce contrôle.
 */
const canDeclarerSurConvention = (
  declarationType?: string | null,
  convention?: { editionRegistre?: number | null } | null,
) =>
  !TYPES_DECLARATION_SUR_PACS_ENREGISTRE.includes(declarationType ?? '') ||
  !!convention?.editionRegistre;

export default canDeclarerSurConvention;
